<template>
  <footer
    class="bg-gng-green-800 color-secondary flex flex-col items-center py-3 px-3"
    ref="footer"
  >
    <ul
      class="inline-flex flex-wrap justify-around gap-3 text-lg text-white underline decoration-yellow-1"
    >
      <li>
        <router-link :to="{ name: RouteName.ABOUT }">{{
          t("About")
        }}</router-link>
      </li>
      <li>
        <router-link :to="{ name: RouteName.TERMS }">{{
          t("Terms")
        }}</router-link>
      </li>
    </ul>
    <div class="text-center flex-1 pt-2 text-white">
      <i18n-t
        tag="span"
        keypath=" Copyright © {date} GatherNGO. All Rights Reserved."
      >
        <template #date
          ><span>{{ new Date().getFullYear() }}</span></template
        >
      </i18n-t>
    </div>
  </footer>
</template>
<script setup lang="ts">
import RouteName from "../router/name";
import { useI18n } from "vue-i18n";

const { t } = useI18n({ useScope: "global" });
</script>

<style lang="scss">
footer > ul > li {
  margin: auto 0;
}
</style>
